import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { delay } from '@/lib/ui'
import { Plate } from '@/components/generals/plate'
import { ABOUT_PLATES, ABOUT_NOTE } from '@/constants/about'

export const AboutPlates: FC = (): ReactNode => {
    return (
        <section id='in-the-field' className='ed-wrap pt-[clamp(48px,6vh,84px)]'>
            <div className='ed-label mb-[clamp(20px,3.2vh,40px)]' data-reveal='up'>
                (04) — In the field
            </div>

            <div className='grid grid-cols-1 gap-y-[clamp(24px,3.4vw,48px)] md:grid-cols-12 md:gap-x-[clamp(20px,3vw,48px)]'>
                {ABOUT_PLATES.map((plate, index) => (
                    <Plate
                        key={plate.src}
                        className={cn(plate.ratio, plate.span)}
                        src={plate.src}
                        alt={plate.alt}
                        caption={plate.caption}
                        sizes='(max-width: 767px) 100vw, 48vw'
                        parallax={plate.parallax}
                        hoverable
                        style={delay(index * 0.05)}
                    />
                ))}

                <div
                    className='flex flex-col justify-end gap-4 border-t border-line-soft pt-6 md:col-span-3 md:col-start-10 md:mt-[1.5vh] md:border-t-0 md:pt-0'
                    data-reveal='up'
                    style={delay(0.2)}
                >
                    <div className='ed-mono text-faint'>
                        {ABOUT_NOTE.label}
                    </div>

                    <p className='ed-body'>
                        {ABOUT_NOTE.body}
                    </p>

                    <div className='ed-mono text-faint'>
                        {ABOUT_NOTE.credit}
                    </div>
                </div>
            </div>
        </section>
    )
}
